var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "float-label",
    {
      attrs: {
        placeholder: _vm.showDefaultValue ? _vm.defaultText : _vm.placeholder,
        value: _vm.value,
        "full-width": _vm.fullWidth,
        large: _vm.large,
        "hide-label": _vm.hideLabel
      }
    },
    [
      _c(
        "select",
        {
          staticClass: "vs-input",
          class: _vm.classes,
          attrs: {
            disabled: _vm.disabled,
            "aria-label": _vm.showDefaultValue
              ? _vm.defaultText
              : _vm.placeholder,
            "aria-describedby": _vm.errorId,
            "aria-disabled": _vm.disabled ? "true" : "false",
            "aria-invalid": _vm.error ? "true" : "false",
            "aria-required": !!_vm.errorId,
            readonly: _vm.readonly
          },
          on: {
            change: function($event) {
              return _vm.$emit("input", $event)
            },
            focus: function($event) {
              return _vm.updateFocus(true)
            },
            blur: function($event) {
              return _vm.updateFocus(false)
            }
          }
        },
        [
          _vm.showPlaceholder
            ? _c(
                "option",
                {
                  attrs: {
                    value: "",
                    disabled: "disabled",
                    selected: "selected"
                  }
                },
                [_vm._v(_vm._s(_vm.hideLabel ? _vm.placeholder : null))]
              )
            : _vm._e(),
          _vm.defaultValue
            ? _c("option", { domProps: { value: _vm.defaultValue } }, [
                _vm._v(_vm._s(_vm.defaultText))
              ])
            : _vm._e(),
          _vm.grouped
            ? [
                _vm.keyProperty && _vm.valueProperty
                  ? _vm._l(_vm.groupedOptions, function(group, key) {
                      return _c(
                        "optgroup",
                        { key: key, attrs: { label: key } },
                        _vm._l(group, function(option) {
                          return _c(
                            "option",
                            {
                              domProps: {
                                selected: option[_vm.keyProperty] == _vm.value,
                                value: option[_vm.keyProperty]
                              }
                            },
                            [_vm._v(_vm._s(option[_vm.valueProperty]))]
                          )
                        }),
                        0
                      )
                    })
                  : _vm._l(_vm.groupedOptions, function(group, key) {
                      return _c(
                        "optgroup",
                        { key: key, attrs: { label: key } },
                        _vm._l(group, function(option) {
                          return _c(
                            "option",
                            {
                              domProps: {
                                selected: option.key == _vm.value,
                                value: option.key
                              }
                            },
                            [_vm._v(_vm._s(option.value))]
                          )
                        }),
                        0
                      )
                    })
              ]
            : _vm.keyValue
            ? _vm._l(_vm.options, function(option, key) {
                return _c(
                  "option",
                  { domProps: { selected: key == _vm.value, value: key } },
                  [_vm._v(_vm._s(option))]
                )
              })
            : _vm.keyProperty && _vm.valueProperty
            ? _vm._l(_vm.options, function(option) {
                return _c(
                  "option",
                  {
                    domProps: {
                      selected: option[_vm.keyProperty] == _vm.value,
                      value: option[_vm.keyProperty]
                    }
                  },
                  [_vm._v(_vm._s(option[_vm.valueProperty]))]
                )
              })
            : _vm._l(_vm.options, function(option) {
                return _c(
                  "option",
                  {
                    domProps: { selected: option == _vm.value, value: option }
                  },
                  [_vm._v(_vm._s(option))]
                )
              })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }